export default "__VITE_ASSET__Bh4DkI0v__"